import { render } from "./Eleicoes2024.vue?vue&type=template&id=94d0ffe6&scoped=true"
import script from "./Eleicoes2024.vue?vue&type=script&lang=js"
export * from "./Eleicoes2024.vue?vue&type=script&lang=js"

import "./Eleicoes2024.vue?vue&type=style&index=0&id=94d0ffe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d0ffe6"]])

export default __exports__